/* eslint-disable array-callback-return, consistent-return -- legacy placeholder module */
/* eslint-disable @stylistic/max-len -- legacy placeholder module */
import React, { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { RenderModule } from 'holocron';
import {
  Button,
  Heading,
  SelectNative,
  SelectNativeOption,
  Surface,
} from '@americanexpress/dls-react';
import { IconArrowLeft } from '@americanexpress/dls-icons';
import {
  deviceType, getUA, osName, osVersion,
} from 'react-device-detect';

const getDetailsFromResponse = (attributesList, key) => {
  let attribute = {
    key: '',
    value: '',
  };
  /* istanbul ignore next */
  if (attributesList.length > 0) {
    attribute = attributesList.find((item) => item.key === key && item.value);
  }
  return attribute.value;
};

const getFormattedAccountList = (data) => {
  const formattedList = [];
  Object.keys(data).map((accountKey) => {
    const hasOpaqueAccountId = (data && data[accountKey] && data[accountKey].opaqueAccountId) || null;
    const cardStatus = (data && data[accountKey] && data[accountKey].status && data[accountKey].status.account_status && data[accountKey].status.account_status[0]) || null;
    const cardLineOfBusinessType = (data && data[accountKey] && data[accountKey].product && data[accountKey].product.line_of_business_type) || '';
    if (hasOpaqueAccountId) {
      const formattedAccount = {
        status: getDetailsFromResponse(data[accountKey].additionalAttributes, 'accountStatus'),
        token: data[accountKey].opaqueAccountId,
        description: data[accountKey].productDisplayName,
        accountNumber: data[accountKey].displayAccountNumber,
        type: data[accountKey].type,
      };
      formattedList.push(formattedAccount);
    } else {
      const formattedAccount = {
        status: cardStatus,
        token: data[accountKey].account_token,
        description: data[accountKey].product.description,
        accountNumber: data[accountKey].account.display_account_number,
        type: cardLineOfBusinessType,
      };
      formattedList.push(formattedAccount);
    }
  });
  return formattedList;
};

const UploadPage = ({
  labels,
  handleLandingPage,
  productList,
  accountSelection,
  accountListStatus,
  accountToken,
  onDropdownChange,
  languageData,
  locale,
  docTypeId,
  handleDocTypeRes,
  handleResponseReset,
  scrollIntoSelect,
  guid,
  handleFormChange,
  scrollIntoForm,
  formHiddenData,
  fieldsData,
  isValidForm,
  handleSubmitCheck,
  handleSubmitRes,
  handleFilePreview,
  downloadProgress,
  previewData,
  handleDownloadProgress,
  kycFlow,
}) => {
  const selectInput = useRef(null);

  useEffect(() => {
    /* istanbul ignore next */
    if (selectInput && selectInput.current) {
      setTimeout(() => selectInput.current.scrollIntoView({ behavior: 'smooth', block: 'center' }), 1000);
    }
  }, [accountListStatus]);

  const renderAccList = (data) => {
    const formattedAccountList = getFormattedAccountList(data);
    const selectOptions = formattedAccountList.map((option) => {
      /* istanbul ignore next */
      if (option.status && (option.status.toLowerCase() === 'active' || option.status.toLowerCase() === 'canceled')) {
        return (
          <SelectNativeOption
            key={`option${option.token}`}
            value={`{"accountToken": "${option.token}","type": "${option.type}",  "accountTypeLabel": "${option.description} ${option.accountNumber}"}`}
          >
            {`${option.description} ${option.accountNumber}`}
          </SelectNativeOption>
        );
      }
    });
    return (
      <div className="pad-1-b" ref={selectInput}>
        <SelectNative
          id="account-listing"
          data-testid="accountListing"
          label={labels.accountNumber}
          onChange={(e) => {
            onDropdownChange(e.target.value, 'true');
          }}
          status={accountListStatus === 'error' ? 'error' : undefined}
          statusMessage={accountListStatus === 'error' ? languageData && languageData.selectAccount : undefined}
          className="width-full"
        >
          <SelectNativeOption key="defaultSelect" value="select">
            {languageData && languageData.selectOneLabel}
          </SelectNativeOption>
          {selectOptions}
        </SelectNative>
      </div>
    );
  };

  return (
    <div>
      <div className="card pad-3-lr-md-up pad-1-lr-sm-down pad-responsive-extra width-full">
        <div className="pad-3-b pad-2-t border-dark-b" style={{ position: 'relative' }}>
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            <Button
              id="backButton"
              data-testid="BackButton"
              name="backButton"
              variant="tertiary"
              icon={<IconArrowLeft title="back icon" titleId="back-icon-id" />}
              iconPosition="start"
              aria-label={labels.back}
              onClick={() => handleLandingPage(true)}
            >
              {labels.back}
            </Button>
          </div>

          <Heading
            level={1}
            variant="sans-large-bold"
            className="text-align-center margin-0"
          >
            <FormattedMessage id="mainHeading" />
          </Heading>
        </div>

        <div className="flex flex-column width-full margin-3-t">
          <div className="margin-4-b col-md-6">
            {renderAccList(productList)}
          </div>

          {accountSelection !== null && (
            <Surface
              className="margin-4-b col-md-6"
              key={`${accountSelection.type}${accountSelection.accountTypeLabel}`}
            >
              <RenderModule
                key={`${accountSelection.type}${accountSelection.accountTypeLabel}`}
                moduleName="axp-document-repositories"
                props={{
                  repoConfigId: 'documentCenter',
                  repositoryView: 'onlyDocument',
                  handleDocTypeRes,
                  onResponseReset: handleResponseReset,
                  icaasMarket: locale,
                  icaasFlowType: accountSelection.type,
                  scrollIntoSelect,
                  guid,
                }}
              />
            </Surface>
          )}

          {docTypeId !== '' && (
            <Surface className="margin-4-b col-md-6">
              <RenderModule
                moduleName="axp-document-upload-form"
                props={{
                  docTypeId,
                  dynamicKey: accountToken,
                  onFormChange: handleFormChange,
                  scrollIntoForm,
                }}
              />
            </Surface>
          )}
        </div>

        {docTypeId !== '' && formHiddenData?.processId && (
          <>
            <Surface className="margin-4-b col-md-12" key={docTypeId}>
              <RenderModule
                moduleName="axp-document-uploader"
                key={docTypeId}
                props={{
                  formDataProps: {
                    ...formHiddenData,
                    ...fieldsData,
                    ...accountSelection,
                    altDocId: accountToken,
                    device: deviceType,
                    userAgent: getUA,
                    osNameVersion: `${osName} ${osVersion}`,
                  },
                  altSubmit: isValidForm && accountSelection !== null && docTypeId !== '' ? null : handleSubmitCheck,
                  onSubmitCall: handleSubmitRes,
                  submitPopLabel: languageData && languageData.submitPopLabel,
                  uploadZoneView: 'ViewOne',
                  fileReqView: 'ViewOne',
                  docListView: 'ViewOne',
                  sizeBarView: 'Disabled',
                  submitView: 'ViewOne',
                  fileTypes: languageData && languageData.fileTypes,
                  fileTypesLabel: languageData && languageData.fileTypesLabel,
                  maxFileSize: 10000000,
                  maxBatchSize: 30000000,
                  maxSizeLabel: languageData.maxSize,
                  maxBatchSizeLabel: languageData.maxBatchSize,
                  filePreview: handleFilePreview,
                  downloadProgress,
                  errorLabel: languageData.optionalUploadType,
                  kycFlow,
                }}
              />
            </Surface>

            <Surface className="margin-4-b col-md-12" key={`${previewData.fileId}${previewData.idx}`}>
              <RenderModule
                moduleName="axp-document-upload-preview"
                props={{
                  documentId: previewData.documentId,
                  fileId: previewData.fileId,
                  processId: formHiddenData && Object.keys(formHiddenData).length > 0
                    ? formHiddenData.processId : previewData.processId,
                  consumerId: formHiddenData && Object.keys(formHiddenData).length > 0
                    ? formHiddenData.consumerId : 'DOCCENTER',
                  fileName: previewData.fileName,
                  fileSize: previewData.fileSize,
                  downloadProgress: handleDownloadProgress,
                }}
              />
            </Surface>
          </>
        )}
      </div>
    </div>
  );
};

export default UploadPage;
/* eslint-enable array-callback-return, consistent-return */
/* eslint-enable @stylistic/max-len */
